module.exports = __webpack_public_path__ + "img/appraisal.c91d2378.png";